import React from 'react';
import styled from 'styled-components';
import { Typo } from 'tmt-ui-kit';

import config from '~/config';

const Container = styled.div`
  padding: 42px 16px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const Icon = styled.img`
  display: block;
`;

const Title = styled(Typo.HeaderTwo)`
  color: ${props => props.theme.greenLighter} !important;
  font-size: 24px !important;
  font-weight: 600 !important;
  margin-bottom: 0px;
`;

const Text = styled(Typo.Paragraph)`
  font-size: 16px !important;
`;

const Submitting = () => {
  return (
    <Container>
      <Icon
        src={`${config.assetPath}/static/images/Affiliate/email.png`}
        srcSet={`${config.assetPath}/static/images/Affiliate/email@2x.png 2x`}
        alt="email"
      />
      <Title>Thanks for submitting!</Title>
      <Text>We will get back to you ASAP.</Text>
    </Container>
  );
};

export default Submitting;
